import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { HaoModel } from '../models/hao.model';
import { PageModel } from 'src/app/core/models/page.model';

@Injectable({
  providedIn: 'root'
})
export class HaoService extends BaseService {
  private baseUrl = '/hao';

  getHaoFromPipefy(after: string, before: string, pageSize: number): Observable<HaoModel[]> {
    const params = new HttpParams().append('after', after).append('before', before).append('pageSize', String(pageSize));
    return this.baseGetWithParams<HaoModel[]>(`${this.baseUrl}/fromPipefy`, params);
  }

  getHaoFromDb(page: any, size: any, active: any, direction: any): Observable<PageModel<HaoModel>> {
    const params = new HttpParams()
        .append('page', page)
        .append('size', size)
        .append('active', active)
        .append('direction', direction)
    ;
    return this.baseGetWithParams<PageModel<HaoModel>>(`${this.baseUrl}/fromDb`, params);
  }

}
